import {LocationSet} from '@emm/core/models/location-set.model';

const separators = /[\s_-]/g;

const stripSeparators = (value: string): string => value.replace(separators, '');

/**
 * Matches a location set against an autocomplete query by tag or name.
 *
 * Tags are inconsistently separated (`ABC_123`, `ABC-123`, `ABC123`), so the
 * comparison also runs with separators removed from both sides.
 */
export function matchesLocationSetFilter(locationSet: LocationSet, filter: string): boolean {
    const query = filter?.toLowerCase().trim();

    if (!query) {
        return true;
    }

    const strippedQuery = stripSeparators(query);

    return [locationSet?.tag, locationSet?.name].some((field) => {
        const value = field?.toLowerCase();

        if (!value) {
            return false;
        }

        return value.includes(query)
            || (!!strippedQuery && stripSeparators(value).includes(strippedQuery));
    });
}
